module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "width": "100%"
    }
  }, [_c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    staticStyle: {
      "width": "100%",
      "max-width": "100%",
      "max-height": "100%",
      "display": "inline-block"
    }
  }, [_c('span', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "",
      "src": "image5.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("MY FRIEND")]), _c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }), _vm._v("Wendy has been running a horse ranch mostly by herself for the last twelve years. She has killed seventeen rattlesnakes with a shotgun, can break a horse and show it and win medals, and has never, ever let anyone tell her that a woman can’t do this alone. This book’s for my friend Wendy.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("My friend Julie has followed her husband around as a Navy wife for over twenty years. She has worked her way back from a hand injury in a motorcycle crash via knitting, takes shit from absolutely no one, and has read more than any human being I know of. This book’s for my friend Julie.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("My friend Barb has lost every adult she’s loved with her whole heart in the space of a year, and she’s still raising her children and fighting for her home. This book’s for my friend Barb.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("My friend Bonnie will answer her e-mail at three-thirty in the morning because she knows that sometimes a time difference makes no difference in how much she’s needed. She’s spent a year and a half telling me that the people who are mean to me about my writing are fuckers and clueless bastards, and really? I can’t hear that enough. This book’s for my friend Bonnie.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("My friend Roxie has lived a full, fierce life with enough empathy and self-assessment to look upon the screw-ups of others with compassion and understanding—she is creative, amazing, and reserves judgment except in the case of blatant meanness or bigotry, and then she has no mercy. This book’s for my friend Roxie.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("My friend Saren sends me "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Supernatural")]), _vm._v(" videos constantly, even if I don’t have time to look up others to send back to her, and she has a husband who offers me virtual brisket with my real Top Ramen. Without her happy indulgence of my weird aging-cougar obsession with young and tasty veal, this book would never have been written. This book’s for my friend Saren.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("My friend Matt has a really flaky wife who would rather write than do housework and who keeps pinning the family’s hopes on what should probably have stayed a hobby with mystique as opposed to an obsession for success. He is kind, empathetic, and never yells at me for traffic tickets even if they send us to the verge of bankruptcy, and he still loves me after twenty years. This book is especially for my friend Matt.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndRagRt"
  }, [_vm._v("Amy Lane")]), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndRagRt"
  }, [_vm._v("January, 2010")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34bd1666","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0003.vue
// module id = 63
// module chunks = 0